/* fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    console.log('Carrito completo:', cart);
    console.log('Productos:', cart.items);
    console.log('Atributos:', cart.attributes);
  })
  .catch(error => console.error('Error al obtener el carrito:', error)); */

/**
 * UTM Tracker
 * Captura, guarda y sincroniza parámetros UTM entre URL, localStorage y carrito
 */
class UTMTracker {
    constructor() {
      this.utmParams = [
        'utm_source', 'utm_medium', 'utm_campaign',
        'utm_term', 'utm_content', 'gclid',
        'fbc', 'ttclid', 'msclkid', 'li_fat_id', 'fbclid'
      ];
      this.localStorageKey = 'levika_utm_params';
      this.debug = false;
  
      document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', () => this.trackUTMs())
        : this.trackUTMs();
    }
  
    /** Log controlado por `this.debug` */
    log(type, ...msg) {
      if (this.debug) console[type](...msg);
    }
  
    /** Extrae UTMs de la URL actual */
    getUTMsFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmData = {};
      this.utmParams.forEach(p => {
        const v = urlParams.get(p);
        if (v) utmData[p] = v;
      });
      return Object.keys(utmData).length ? utmData : null;
    }
  
    /** Recupera UTMs guardados en localStorage */
    getStoredUTMs() {
      try {
        return JSON.parse(localStorage.getItem(this.localStorageKey)) || null;
      } catch {
        return null;
      }
    }
  
    /** Guarda UTMs en localStorage */
    storeUTMs(utmData) {
      if (!utmData) return;
      localStorage.setItem(this.localStorageKey, JSON.stringify(utmData));
      this.log('info', '[INFO] UTMs guardados en localStorage:', utmData);
    }
  
    /** Obtiene UTMs almacenados como atributos del carrito */
    async getCartAttributes() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (!cart.attributes) return null;
  
        const utmData = {};
        this.utmParams.forEach(p => {
          const v = cart.attributes[`_${p}`];
          if (v) utmData[p] = v;
        });
  
        return Object.keys(utmData).length ? utmData : null;
      } catch (e) {
        this.log('error', '[ERROR] getCartAttributes:', e);
        return null;
      }
    }
  
    /** Verifica si los UTMs en carrito coinciden exactamente con los guardados */
    cartMatches(a, b) {
      return a && b && Object.keys(b).every(k => a[k] === b[k]);
    }
  
    /** Establece UTMs en atributos del carrito */
    async setCartAttributes(utmData) {
      if (!utmData) return;
      const attributes = {};
      Object.keys(utmData).forEach(k => (attributes[`_${k}`] = utmData[k]));
      return this.updateCart(attributes, '[INFO] UTMs guardados en carrito:');
    }
  
    /** Limpia todos los UTMs del carrito */
    async clearCartAttributes() {
      const attributes = {};
      this.utmParams.forEach(p => (attributes[`_${p}`] = null));
      return this.updateCart(attributes, '[INFO] UTMs limpiados del carrito');
    }
  
    /** Helper para actualizar atributos del carrito */
    async updateCart(attributes, msg) {
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes })
        });
        const data = await res.json();
        this.log('info', msg, attributes);
        return data;
      } catch (e) {
        this.log('error', '[ERROR] updateCart:', e);
      }
    }
  
    /** Flujo principal: decide de dónde tomar UTMs y cómo sincronizarlos */
    async trackUTMs() {
      try {
        const stored = this.getStoredUTMs();
        const urlUTMs = !stored ? this.getUTMsFromURL() : null;
        if (!stored) await this.clearCartAttributes();
        const cart = await this.getCartAttributes();
  
        this.log('warn', { urlUTMs, stored, cart });
  
        if (urlUTMs && !stored) {
          this.storeUTMs(urlUTMs);
          return this.setCartAttributes(urlUTMs);
        }
  
        if (stored && !cart) {
          return this.setCartAttributes(stored);
        }
  
        if (stored && cart && !this.cartMatches(cart, stored)) {
          return this.setCartAttributes(stored);
        }
  
        if (cart && !stored) {
          this.storeUTMs(cart);
        }
      } catch (e) {
        this.log('error', '[ERROR] trackUTMs:', e);
      }
    }
  }
  
  // Auto-init
  (() => new UTMTracker())();